module.exports = __webpack_public_path__ + "static/media/CCTP -  English Teacher_s Guide (v2).61e21260.pptx";